<template>
  <template v-if="hasAdvertisementLink(currentAd)">
    <a
      v-if="isExternalAdvertisementLink(currentAd)"
      :href="getExternalLink(currentAd?.link)"
      target="_blank"
      rel="noopener noreferrer"
      class="relative inline-block mb-3 w-full h-[144px]"
    >
      <img
        class="object-cover rounded-md h-full w-full"
        :src="currentAd?.image"
        alt="poster-banner"
      />
      <div
        style="background-color: rgba(96, 165, 250, 0.69)"
        class="absolute w-full px-3 py-1 bottom-0 left-0 text-white z-10 rounded-b-lg"
      >
        {{ currentAd?.title }}
      </div>
    </a>
    <router-link
      v-else
      :to="{
        name: getRouteParams(currentAd).name,
        params: getRouteParams(currentAd).params,
        query: getRouteParams(currentAd).query,
      }"
      class="relative inline-block mb-3 w-full h-[144px]"
    >
      <img
        class="object-cover rounded-md h-full w-full"
        :src="currentAd?.image"
        alt="poster-banner"
      />
      <div
        style="background-color: rgba(96, 165, 250, 0.69)"
        class="absolute w-full px-3 py-1 bottom-0 left-0 text-white z-10 rounded-b-lg"
      >
        {{ currentAd?.title }}
      </div>
    </router-link>
  </template>
  <div v-else class="relative inline-block mb-3 w-full h-[144px]">
    <img
      class="object-cover rounded-md h-full w-full"
      :src="currentAd?.image"
      alt="poster-banner"
    />
    <div
      style="background-color: rgba(96, 165, 250, 0.69)"
      class="absolute w-full px-3 py-1 bottom-0 left-0 text-white z-10 rounded-b-lg"
    >
      {{ currentAd?.title }}
    </div>
  </div>
</template>

<script>
import {
  getRouteParams,
  getExternalLink,
  hasAdvertisementLink,
  isExternalAdvertisementLink,
} from '@/helpers';

export default {
  name: 'SquarePosterBanner',
  props: {
    content: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      adInterval: null,
      adImageIndex: 0,
      time: 0,
      currentAd: {
        link: '/',
        link_type: 0,
        image: '/img/logo.webp',
      },
    };
  },
  methods: {
    getRouteParams,
    getExternalLink,
    hasAdvertisementLink,
    isExternalAdvertisementLink,
    runInterval() {
      this.time = this.currentAd?.duration * 1000;
      this.adInterval = setInterval(this.changeImage, this.time);
    },
    changeImage() {
      this.adImageIndex = (this.adImageIndex + 1) % this.content.length;
      this.currentAd = this.content[this.adImageIndex];
      clearInterval(this.adInterval);
      this.runInterval();
    },
  },
  mounted() {
    this.currentAd = this.content[0];
    if (this.content.length > 1) {
      this.runInterval(); // Change image every 30 seconds
    }
  },
  unmounted() {
    clearInterval(this.adInterval);
  },
};
</script>
